import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { parseManifest } from "@equipped/core/core/manifest";
import { packFields } from "../packFields";
import { renderFields } from "../fieldTypes";
import { DocumentPanel } from "./DocumentPanel";

const FIELDS = renderFields(packFields);

export function PackPanel({
  value,
  onChange,
  onSave,
  onDiscard,
  dirty,
  saving,
  saveError,
  onAddLesson,
}: {
  value: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  onSave: () => void;
  onDiscard: () => void;
  dirty: boolean;
  saving: boolean;
  saveError: string | null;
  onAddLesson: () => void;
}) {
  const lessonCount = Array.isArray(value.lessons) ? value.lessons.length : 0;
  return (
    <DocumentPanel
      title={(value.title as string) || "New pack"}
      fields={FIELDS}
      value={value}
      onChange={onChange}
      onSave={onSave}
      onDiscard={onDiscard}
      dirty={dirty}
      saving={saving}
      saveError={saveError}
      validate={parseManifest}
      extra={
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {lessonCount} {lessonCount === 1 ? "lesson" : "lessons"} — select one in the tree to edit it, reorder, or remove it.
          </Typography>
          <Button size="small" variant="outlined" onClick={onAddLesson}>
            + Add lesson
          </Button>
        </Box>
      }
    />
  );
}
